import React, { useEffect, useState } from 'react'
import { PaginationShow } from '../../comman/action/Pagination'
import NotFound from '../../components/not-found/NotFound'
import { useSearchParams } from 'react-router-dom';
import useFullPageLoader from '../../hooks/useFullPageLoader';
import Switch from '../../components/Switch/Switch';
import { IconButton } from '@mui/material';
import QuizIcon from "@mui/icons-material/Quiz";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { dateFormat } from '../../components/Form';
import { Button } from '../../components/Button/Button';
import useDebounce from '../../hooks/useDebounce';
import { fathFaqApi } from '../../services/faq';
import { catchMessage, elseMessage } from '../../comman/Message';
import { DescriptionModal, ViewMore } from '../../comman/action/ViewMore';
import AddFaq from './AddFaq';
import EditFaq from './EditFaq';
import ChangeStatusFaq from './ChangeStatusFaq';
import { DeleteIcon } from '../../comman/action/DeleteIcon';
import DeleteFaq from './DeleteFaq';

const FaqManagement = () => {

    const [searchParam, setSearchParam] = useSearchParams();
    const [search, setSearch] = useState(searchParam.get("query") || "")
    const debounceValue = useDebounce(search || "", 300)
    const activePage = +searchParam.get("page") || 1
    const [total, setTotal] = useState(0)

    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [faqList, setFaqList] = useState([])

    const [orderByName, setOrderByName] = useState('');
    const [fieldName, setFieldName] = useState('')
    const [direction, setDirection] = useState('ASC')

    const [moreModal, setMoreModal] = useState(false)
    const [moreValue, setMoreValue] = useState('')
    const [title, setTitle] = useState('');

    const [addModal, setAddModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [editId, setEditId] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)


    const [statusModal, setStatusModal] = useState(false);
    const [statusValue, setStatusValue] = useState('');
    const [statusName, setStatusName] = useState('')
    const [statusId, setStatusId] = useState('');
    //--------------handle-page------------------------
    const handlePageChange = (event) => {
        searchParam.set("page", event)
        setSearchParam(searchParam)
    }
    //----------see-more-in-modal----------
    const handleSeeMore = (desc) => {
        setMoreModal(true)
        setMoreValue(desc)
        setTitle('Description')
    }
    //----------see-more-in-modal----------
    const handleSeeMoreTitle = (title) => {
        setMoreModal(true)
        setMoreValue(title)
        setTitle('Title')
    }
    //----------update-faq----------
    const updateHandler = (id) => {
        setEditModal(true)
        setEditId(id)
    }
    //----------delete-faq----------
    const deleteHandler = (id, name) => {
        setDeleteModal(true)
        setEditId(id)
        setStatusName(name)
    }
    //----------status-handler----------
    const statusUpdateHandler = (id, status, name) => {
        setStatusModal(true);
        setStatusId(id);
        setStatusValue(status);
        setStatusName(name)
    };
    //--------------sorting-name------------------------
    const orderByNameFun = () => {
        const newDirection = orderByName === 'ASC' ? "DESC" : "ASC";
        setOrderByName(newDirection);
        setFieldName("title")
        setDirection(newDirection)
    };
    //------------------listing-Api----------------------------------
    const fathFaq = async (
        page = activePage,
        search = debounceValue,
        sortField = fieldName,
        sortDirection = direction,
    ) => {
        showLoader()
        setFaqList([])
        try {
            const res = await fathFaqApi({ page, search, sortField, sortDirection })
            if (res?.data?.status === 200) {
                hideLoader()
                setFaqList(res?.data?.data?.faq || [])
                setTotal(res?.data?.data?.total)
            } else {
                hideLoader()
                elseMessage(res)
                setFaqList([])
            }
        } catch (err) {
            hideLoader()
            catchMessage(err)
            setFaqList([])
        }
    }
    useEffect(() => {
        if (debounceValue) {
            searchParam.set("query", debounceValue)
        } else {
            searchParam.delete("query")
        }
        if (activePage === 1) {
            searchParam.delete("page")
        }
        setSearchParam(searchParam)
        fathFaq(activePage, debounceValue, fieldName, direction)
    }, [activePage, debounceValue, searchParam, fieldName, direction])//fieldName, direction

    useEffect(() => {
        if (search) {
            searchParam.set("page", "")
        }
    }, [search])
    return (
        <>
            {loader}
            <div className="WrapperArea">
                <div className="WrapperBox">
                    <div className="TitleBox">
                        <h4 className="Title">FAQ Management</h4>
                        <Button onClick={() => setAddModal(true)}>Add FAQ</Button>

                    </div>
                    <div className="FilterBox FilterArea">
                        <div className="form-group search">
                            <input type="search"
                                className="form-control"
                                placeholder='Search'
                                value={search || ""}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="content-table">
                        <table>
                            <thead>
                                <tr>

                                    <th>S. No.</th>
                                    <th>
                                        <div className="sorting-th" onClick={orderByNameFun}>
                                            <span>title</span>
                                            {orderByName === 'ASC' ? (
                                                <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                            ) : (
                                                <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                            )}
                                        </div>
                                    </th>
                                    <th>Created At</th>
                                    <th>Description</th>
                                    <th className="text-center"> Action </th>
                                </tr>
                            </thead>

                            <tbody>
                                {faqList.length > 0 ? faqList.map((
                                    { _id,
                                        title,
                                        description,
                                        createdAt,
                                        status,
                                    }, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <tr>
                                                <td>{++index + (activePage - 1) * 10}</td>
                                                <td>
                                                    <ViewMore value={title} handleSeeMore={handleSeeMoreTitle} length={20} />
                                                </td>
                                                <td>{dateFormat(createdAt) || "N/A"}</td>
                                                <td>
                                                    <ViewMore value={description} handleSeeMore={handleSeeMore} length={20} />
                                                </td>
                                                <td>
                                                    <div className="d-flex justify-content-center">
                                                        <IconButton aria-label="update" onClick={() => updateHandler(_id)} >
                                                            <DriveFileRenameOutlineIcon sx={{ color: "#C86337", fontSize: 26 }} />
                                                        </IconButton>
                                                        <Switch checked={status}
                                                            onChange={() => statusUpdateHandler(_id, status, title)}
                                                        />
                                                        <DeleteIcon onClick={() => deleteHandler(_id, title)} />
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    )
                                }) :
                                    <NotFound
                                        cols={5}
                                        msg="No Faq Found!"
                                        icon={<QuizIcon style={{ fontSize: 48 }} />}
                                        loader={loader}
                                    />
                                }
                            </tbody>
                        </table>
                    </div>
                    <PaginationShow
                        total={total}
                        activePage={activePage}
                        handlePageChange={handlePageChange}
                    />

                    {/* -------------view-more-modal------------------- */}
                    <DescriptionModal
                        show={moreModal}
                        close={() => setMoreModal(false)}
                        value={moreValue}
                        title={title}
                    />
                    <AddFaq
                        show={addModal}
                        close={() => setAddModal(false)}
                        listing={fathFaq}
                    />
                    <EditFaq
                        show={editModal}
                        close={() => setEditModal(false)}
                        listing={fathFaq}
                        id={editId}
                    />
                    <ChangeStatusFaq
                        show={statusModal}
                        close={() => setStatusModal(false)}
                        id={statusId}
                        status={statusValue}
                        listing={fathFaq}
                        name={statusName}
                    />
                    <DeleteFaq
                        show={deleteModal}
                        close={() => setDeleteModal(false)}
                        listing={fathFaq}
                        id={editId}
                        name={statusName}
                    />
                </div>
            </div >
        </>
    )
}

export default FaqManagement